import React from 'react'
class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <div className="subfooter">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-12">
              <p className="text-center">
                Copyright © 2017 NicheSolv
                <font color="olivedrab" />
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/footer/Footer.js